<template>
    <div class="page-content margin-bottom-60">
        <div class="center-text own-title red margin-bottom-20">
            BOSS
        </div>

        <div class="content card round-medium" :style="loadBg">
            <div>
                <div class="ipad-display text-center">
                    <img :src="'images/mpower-new/boss/iPad/01.png'" class="img-resize ipad  margin-bottom-40">
                    <div class="responsive-iframe">
                        <video width="90%" controls onloadedmetadata="this.muted = true" playsinline muted loop>
                            <source :src="'images/mpower-new/boss/video/01.mp4'" type="video/mp4">
                        </video>
                    </div>
                    <div class="responsive-iframe">
                        <video width="90%" controls onloadedmetadata="this.muted = true" playsinline muted loop>
                            <source :src="'images/mpower-new/boss/video/02.mp4'" type="video/mp4">
                        </video>
                    </div>
                    <img :src="'images/mpower-new/boss/iPad/02.png'" class="img-resize ipad">
                    <img :src="'images/mpower-new/boss/iPad/03.png'" class="img-resize ipad">
                </div>
                <div class="mobile-display">
                    <img v-bind:src="'images/mpower-new/boss/mobile/01.png'" class="responsive-image ipad-responsive-img mx-auto mobile margin-bottom-40">
                        <div class="responsive-iframe">
                            <video width="90%" controls onloadedmetadata="this.muted = true" playsinline muted loop>
                                <source :src="'images/mpower-new/boss/video/01.mp4'" type="video/mp4">
                            </video>
                        </div>
                        <div class="responsive-iframe">
                            <video width="90%" controls onloadedmetadata="this.muted = true" playsinline muted loop>
                                <source :src="'images/mpower-new/boss/video/02.mp4'" type="video/mp4">
                            </video>
                        </div>
                    <img v-bind:src="'images/mpower-new/boss/mobile/02.png'" class="responsive-image ipad-responsive-img mx-auto mobile">
                </div>
            </div>
        </div>
    </div>
</template>
<style scoped>
.mx-auto {
    margin: 0 auto;
}

.boss-desc {
    font-family: "Montserrat-Medium";
    color: #000000;
    font-size: 14px;
    line-height: 16px;
    text-align: left;
}


.round-medium{
    border: 3px solid #A31F08;
}

.pb{
    padding-bottom: 50px;
}

.word-content{
        padding-left: 7%;
        padding-right: 7%;
    }


@media(min-width: 765px){
    .ipad-responsive-img {
        max-width: 60% !important;
    }  
}
</style>
<script>
export default {
    name: 'Boss',
    computed: {
        loadBg(){
            return {
                'background-size': 'cover',
                'background-position': 'center',
                'background-repeat': 'no-repeat',
                'background-color': '#fff'
            }
        },
    },
    components: {
      
    }
}
</script>
